<template>
  <div class="pic-item" @click.stop="previewImage">
    <img class="pic" v-lazy="data.info" :src="data.info" />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    list: {
      type: Array,
      default: () => {
        ;[]
      }
    },
    index: {
      type: Number,
      default: 0
    },
    index1: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  created() {
    console.log(this.data)
  },
  methods: {
    previewImage() {
      this.$emit('click', this.index, this.index1)
    }
  }
}
</script>
<style lang="scss" scoped>
.pic-item {
  overflow: hidden;
  position: relative;
  width: 28.8vw;
  height: 28.8vw;
  border-radius: 1.1vw;
  margin-left: 3.4vw;
  margin-bottom: 2.5vw;
}
.pic {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  object-fit: cover;
}
</style>
